import { useEffect } from 'react';

import { Button, Modal, ModalActions, ModalContent, ModalHeader, Typography } from '@braskai/ui-kit';

import { CardMedia } from '@mui/material';

import { useOnboardingEvent } from '@/features/user/onboarding';

import { useGetSpaces } from '@/entities/teamspace';
import { useOnboardingStore } from '@/entities/user/currentUser';

import WelcomeImage from '@/shared/assets/images/teamspace-welcom-banner.jpg';
import { useInterfaceLanguage } from '@/shared/i18n';

import { useTeamspaceWelcomeModal } from '../model/useTeamspaceWelcomeModal';

export const TeamspaceWelcomeModal = () => {
  const { t } = useInterfaceLanguage();
  const { spaceId, reset } = useTeamspaceWelcomeModal();
  const changeStepStatus = useOnboardingStore((state) => state.changeStepStatus);
  const { data: spaces } = useGetSpaces();
  const showOnboardingEvent = useOnboardingEvent('manageTeamspace_v1', true);

  const spaceName = spaces?.find((space) => space.id === spaceId)?.name || '';

  const onClose = () => {
    reset();

    showOnboardingEvent();
  };

  useEffect(() => {
    if (spaceId) {
      changeStepStatus('manageTeamspace_v1', true);
    }
  }, [spaceId, changeStepStatus]);

  if (!spaceId) {
    return null;
  }

  return (
    <Modal open onClose={onClose}>
      <ModalHeader.Container sx={{ padding: '0px !important' }} onClose={onClose}>
        <CardMedia component="img" src={WelcomeImage} />
      </ModalHeader.Container>
      <ModalContent>
        <Typography color="common.black" component="h2" variant="title-3-sb">
          {t('teamspace.welcome.title', { name: spaceName })}
        </Typography>
        <Typography color="grey.500" mt={1} variant="body-1">
          {t('teamspace.welcome.invited')} <br /> {t('teamspace.welcome.createFirst')}
        </Typography>
      </ModalContent>
      <ModalActions>
        <Button data-testid="teamspace-welcome-modal-get-started" onClick={onClose}>
          {t('teamspace.welcome.getStarted')}
        </Button>
      </ModalActions>
    </Modal>
  );
};
